var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRulesOffice = function SvgRulesOffice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "rules-office_svg__\\u0421\\u043B\\u043E\\u0439_1",
    x: 0,
    y: 0,
    viewBox: "0 0 135 135"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".rules-office_svg__st14{fill:#d6c990}.rules-office_svg__st15{fill:#f7e6a1}.rules-office_svg__st16{fill:#7383bf}.rules-office_svg__st18{fill:#d1af43}.rules-office_svg__st19{fill:#efce4a}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6 66v35.7l4.3-1.7 14.8-14.8zM53.9 33.2l-5.6-5.6-17.8 7.1v7.1l23.4 23.4zm0 0",
    className: "rules-office_svg__st14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7 59.2V55L53.9 33.2v31.9l7.9 7.9zm0 0",
    className: "rules-office_svg__st15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7 87v-3.6l-1.8 1.8zm0 0",
    className: "rules-office_svg__st16"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.9 69.2 75.7 83.4V87L86 97.3l11.5-4.9V76.8zm0 0",
    style: {
      fill: "#6472a0"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 37.4v-12l-19 8.2L89.9 45zM77.8 57.1 75.7 55v4.1zm0 0",
    className: "rules-office_svg__st14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m105.7 29.2-8.2-3.8v11.9zm0 0",
    className: "rules-office_svg__st15"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.9 76V38.2L102 57.1zM97.5 92.4l23.4 9.3v-1.5L97.5 76.8zm0 0",
    className: "rules-office_svg__st16"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9 81V65.2L30.6 41.8V66l19.1 19.1zm0 0",
    className: "rules-office_svg__st18"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m62.9 96.2 12.8 5.5V87l-1.8-1.8zM53.9 65.2V81l7.9-7.9zm0 0",
    className: "rules-office_svg__st19"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7 101.7 86 97.3 75.7 87zM53.9 25.4l-5.6 2.2 5.6 5.6zm0 0",
    className: "rules-office_svg__st18"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m75.7 34.8-21.8-9.3v7.8L75.7 55zm0 0",
    className: "rules-office_svg__st19"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m75.7 55 2.1 2.1L89.9 45 78.5 33.6l-2.8 1.2zM97.5 76.8V61.6l-7.6 7.6zm0 0",
    className: "rules-office_svg__st18"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m102 57.1-4.5 4.5v15.2l23.4 23.4V76zm0 0",
    className: "rules-office_svg__st19"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m53.9 89.4-4.2-4.2L34.9 100l19-7.6zm0 0",
    className: "rules-office_svg__st18"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m53.9 92.4 5.2 2.2-5.2-5.2zM61.8 73.1l12.1 12.1 1.8-1.8V59.2zm0 0",
    className: "rules-office_svg__st19"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 37.4 89.9 45l7.6 7.6zM75.7 59.2v24.2l14.2-14.2-12.1-12.1zm0 0",
    className: "rules-office_svg__st18"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m97.5 52.6 4.5 4.5 18.9-18.9v-1.9l-15.2-7.1-8.2 8.1zm0 0",
    className: "rules-office_svg__st19"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m49.7 85.2 4.2 4.2V81zm0 0",
    className: "rules-office_svg__st18"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8 73.1 53.9 81v8.4l5.2 5.2 3.8 1.6 11-11zm0 0",
    className: "rules-office_svg__st19"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9 45 77.8 57.1l12.1 12.1 7.6-7.6v-9zm0 0",
    className: "rules-office_svg__st18"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m97.5 61.6 4.5-4.5-4.5-4.5zm0 0",
    className: "rules-office_svg__st19"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.9 14.7c-9.7 0-17.6 7.9-17.6 17.6s17.6 26.5 17.6 26.5S83.5 42 83.5 32.3s-7.9-17.6-17.6-17.6m0 27.5c-5.5 0-9.9-4.4-9.9-9.9s4.4-9.9 9.9-9.9 9.9 4.4 9.9 9.9c-.1 5.5-4.5 9.9-9.9 9.9",
    style: {
      fill: "#f44336"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9 20.5c-6.5 0-11.8 5.3-11.8 11.8s5.3 11.8 11.8 11.8 11.8-5.3 11.8-11.8-5.3-11.8-11.8-11.8m0 19.8c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8c-.1 4.4-3.6 8-8 8",
    style: {
      fill: "#e53935"
    }
  }));
};
export default SvgRulesOffice;